import React from 'react'

import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'

import './AdminLayout.css'

export type AdminNavKey =
  | 'dashboard'
  | 'plants'
  | 'contracts'
  | 'penalty'
  | 'reports'
  | 'monitoring'
  | 'manpower'
  | 'inventory'
  | 'collaboration'
  | 'cctv'
  | 'settings'

type AdminLayoutProps = {
  title: string
  activeNav: AdminNavKey
  children: React.ReactNode
  pageTitle?: string
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  title,
  activeNav,
  children,
  pageTitle,
}) => {
  const history = useHistory()
  const docTitle = pageTitle ?? title

  const go = (path: string) => () => history.push(path)

  const navItem = (key: AdminNavKey, label: string, path?: string) => {
    const active = activeNav === key
    return (
      <button
        type="button"
        key={key}
        className={`admin-nav-btn${active ? ' admin-nav-btn--active' : ''}`}
        onClick={path ? go(path) : undefined}
        disabled={!path}
      >
        {label}
      </button>
    )
  }

  return (
    <div className="admin-root">
      <Helmet>
        <title>{docTitle}</title>
        <meta property="og:title" content={docTitle} />
      </Helmet>
      <aside className="admin-sidebar">
        <img
          className="admin-logo"
          src="/namamigangelogohindi11123-19br-200h.png"
          alt="Namami Gange"
        />
        <nav className="admin-nav" aria-label="Main">
          {navItem('dashboard', 'Dashboard', '/dashboard')}
          {navItem('plants', 'Plants', '/plants')}
          {navItem('contracts', 'Contracts', '/contatcts')}
          {navItem('penalty', 'Penalty', '/penalty')}
          {navItem('reports', 'Reports', '/reports')}
          {navItem('monitoring', 'Real time monitoring', '/monitoring')}
          {navItem('manpower', 'Manpower', '/manpower')}
          {navItem('inventory', 'Inventory', '/inventory')}
          {navItem('collaboration', 'Collaboration', '/collaboration')}
          {navItem('cctv', 'CCTV Monitoring', '/cctv')}
        </nav>
        <div className="admin-nav-footer">
          {navItem('settings', 'Settings', '/settings')}
        </div>
      </aside>
      <div className="admin-main">
        <header className="admin-header">
          <h1 className="admin-header-title">{title}</h1>
          <div className="admin-header-actions">
            <img
              src="/ellipse37041120-za0o-200h.png"
              alt=""
              className="admin-header-ico"
            />
            <img
              src="/ellipse37051120-ifso-200h.png"
              alt=""
              className="admin-header-ico"
            />
            <img src="/line4771120-c2ag.svg" alt="" className="admin-header-ico admin-header-ico--line" />
            <img src="/line4781120-rxjc.svg" alt="" className="admin-header-ico admin-header-ico--line" />
            <img src="/alert1121-yee.svg" alt="Notifications" className="admin-header-ico" />
            <img src="/image1120-bwth-200h.png" alt="" className="admin-header-avatar" />
            <div className="admin-header-user">
              <span className="admin-header-name">Rajesh Nair</span>
              <span className="admin-header-role">Super Admin</span>
            </div>
            <img src="/chevron1120-kk1e.svg" alt="" className="admin-header-ico admin-header-ico--sm" />
            <button
              type="button"
              className="admin-signout"
              onClick={go('/')}
              aria-label="Sign out"
            >
              <img src="/arrowexit1121-yl5j.svg" alt="" />
            </button>
          </div>
        </header>
        <div className="admin-content">{children}</div>
      </div>
    </div>
  )
}

export default AdminLayout
